import React from "react";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import './styles.css';

const BaixoCusto = () => {
  return (
    <>
      <Card className="text-center">
        <Card.Header><div className="opcoes">Roteadores de Baixo Custo</div></Card.Header>
        <Card.Body>
          {/* <Card.Title> Crucial para garantir 
            o desempenho ótimo das redes Wi-Fi. </Card.Title> */}
          <Card.Text>
          <div className="opcoes">
            <strong>Desempenho e Capacidade Limitados: </strong>
            Incapazes de lidar com muitas conexões simultâneas e altas demandas 
            de largura de banda, inadequados para atividades intensivas.
          </div> 
          <div className="opcoes">
            <strong>Cobertura Fraca: </strong>
            Sinal de alcance limitado, insuficiente para grandes áreas ou casas com muitas obstruções.
          </div> 
          <div className="opcoes">
            <strong>Segurança Básica: </strong>
            Oferecem níveis de segurança que podem não ser suficientes para proteger contra ameaças mais 
            avançadas, expondo a rede a maiores riscos.
          </div> 
          </Card.Text>
          {/* <Button variant="primary">Go somewhere</Button> */}
        </Card.Body>
        <Card.Footer className="text-muted"><div className="opcoes">
        Para garantir uma decisão acertiva ao investir em equipamentos de rede Wi-Fi, é essencial analisar e 
        ponderar o investimento com base nas necessidades específicas de cada cenário</div>
        </Card.Footer>
      </Card>
    </>
  )
}
export default BaixoCusto;